import { useEffect, useState, ChangeEvent, MouseEvent } from 'react';
import Modal from 'react-bootstrap/Modal';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Scope } from '../../types';
import {
  listScopesAction,
  selectScopes,
} from '../scope/scopeSlice';

type Props = {
  tenant_id: string;
  show: boolean;
  ignore_scopes: string[];
  onClose: (selected_scopes: Scope[]) => void;
};

export function SelectScopesModal({ tenant_id, show, ignore_scopes, onClose }: Props) {
  const dispatch = useAppDispatch();
  const all_scopes = useAppSelector(selectScopes);
  const ignore_set = new Set(ignore_scopes);
  const scopes = all_scopes.filter(scope => !ignore_set.has(scope.scope_id));
  const [is_selecteds, setIsSelecteds] = useState<boolean[]>(scopes.map(() => false));
  useEffect(() => {
    if (show) {
      dispatch(listScopesAction({ tenant_id }));
    }
  }, [tenant_id, dispatch, show]);
  useEffect(() => {
    if (scopes.length !== is_selecteds.length) {
      setIsSelecteds(scopes.map(() => false));
    }
  }, [scopes, is_selecteds.length, ignore_scopes]);
  const handleClickRow = (event: MouseEvent, index: number) => {
    const copied = [...is_selecteds];
    copied[index] = !copied[index];
    setIsSelecteds(copied);
  };
  const handleSelectItem = (event: ChangeEvent<HTMLInputElement>, index: number) => {
    const copied = [...is_selecteds];
    copied[index] = event.target.checked;
    setIsSelecteds(copied);
  };
  const handleAdd = () => {
    let select_scopes = scopes.filter((scope_id, index) => is_selecteds[index]);
    onClose(select_scopes);
  };
  return (
    <Modal show={show} onHide={() => onClose([])} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Scopes List</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-hover">
          <thead className="table-dark">
            <tr>
              <th scope="col"></th>
              <th scope="col">ScopeId</th>
              <th scope="col">Title</th>
            </tr>
          </thead>
          <tbody>
            {scopes.map((scope, index) => {
              return (
                <tr key={index} onClick={(e) => handleClickRow(e, index)}>
                  <th scope="row">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox"
                        checked={is_selecteds[index] ?? false}
                        onChange={(e) => handleSelectItem(e, index)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                  </th>
                  <td>{scope.scope_id}</td>
                  <td>{scope.title}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={() => onClose([])}>
          Close
        </button>
        <button className="btn btn-primary" onClick={() => handleAdd()}>
          Add
        </button>
      </Modal.Footer>
    </Modal>
  );
}
